
export enum ComputedState {
  NoActiveOrder= 'NoActiveOrder',
  CloseUnsold= 'CloseUnsold',
  UnderNegotiation= 'UnderNegotiation',
  PendingPayment= 'PendingPayment',
  Sold= 'Sold',

}